import React, { Component } from 'react';

// DEPENDENCIES
import clsx from 'clsx';

// GLOBAL FUNCTIONS
import { doCallback } from 'functions';

// LOCAL FUNCTIONS
import { filterSelectOptions } from '../functions';

// REACT-SELECT COMPONENTS
import { components } from 'react-select';

// STYLES
import styles from '../select.module.scss';

// FUNCTIONS
const findOption = (options, searchString) => options.find(o => String(o.label).toLowerCase() === searchString.toLowerCase());

// MAIN COMPONENT
// eslint-disable-next-line react/prefer-stateless-function
class Input extends Component {
  selectOption = (e, strict = true) => {

    const { value } = e.target
    if (!value) return; // If no value, ignore

    const { value: selectValue } = this.props.selectProps;
    const existingOption = strict ? findOption(selectValue, value) : selectValue.find(o => filterSelectOptions(o, value));
    if (existingOption) { // If value exists, ignore
      if (this.props.selectProps.isMulti) this.props.selectOption({}) // If multi-select, clear input
      return;
    }

    const { options: selectOptions } = this.props.selectProps;
    const validOption = strict ? findOption(selectOptions, value) : selectOptions.find(o => filterSelectOptions(o, value))
    if (validOption) {
      this.props.selectOption(validOption); // If value matches option, select option
      return;
    }

    if (this.props.selectProps.allowCustom) return this.props.selectOption({value}); // Select custom value, if allowed

    return this.props.selectOption({}); // Otherwise, clear input
  }

  handleKeyDown = e => {

    if (!this.props.selectProps.allowCustom && !this.props.selectProps.allowFiltering) {
      e.stopPropagation();
      e.preventDefault();
      return
    }

    const { name, formikBag: { setFieldTouched } } = this.props.selectProps;
    doCallback(setFieldTouched, name);
    doCallback(this.props.onKeyDown, e);

    switch (e.key) {
      case 'Enter':
        e.stopPropagation();
        e.preventDefault();
        e.target.blur();
        this.selectOption(e); // This must be last to be sure it overrides anything triggered by blur()
        return;
      case 'Tab':
        e.stopPropagation(); // This is necessary to prevent default option selecting
        if (this.props.isMulti && e.target.value) e.preventDefault(); // This is necessary to maintin focus
        this.selectOption(e);
        return;
      case ',':
        if (!this.props.isMulti) return;
        e.stopPropagation();
        e.preventDefault();
        this.selectOption(e);
        return;
      default:
        return;
    }
  }

  render() {
    return (
      <components.Input
        {...this.props}
        className={clsx(
          'select-input',
          styles.input,
          this.props.className,
          !this.props.selectProps.allowCustom && !this.props.selectProps.allowFiltering && styles.hidden
        )}
        onKeyDown={this.handleKeyDown}
      />
    )
  }
}

export default Input
